// extracted by mini-css-extract-plugin
module.exports = {"footer":"b5_kz","footer__line":"b5_k0","footer__copyright":"b5_k1"};